// extracted by mini-css-extract-plugin
module.exports = {"mds-td":"mds-td__taxonomy","mds-table--spacious":"mds-table--spacious__taxonomy","mds-td--right":"mds-td--right__taxonomy","mds-tr":"mds-tr__taxonomy"};